import React, { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import { AppProvider } from './app/providers/AppProvider';
import { ApolloAppProvider } from './utils/apollo';
import OnboardingApp from './App';

// Importar estilos principales de Onboarding (ya encapsulados dentro de .Onboarding)
import './sass/main.scss';
import { LoadScript } from '@react-google-maps/api';
import { GOOGLE_API_KEY } from '@common/config/environments';
import { useGetUserLoggin } from 'services/user/querys';
import { useNavigate } from 'react-router-dom';

const Onboarding = () => {

  const navigate = useNavigate();
  
  const { error } = useGetUserLoggin();

  useEffect(() => {
    if (error?.message.includes('Unauthorized') && localStorage.getItem('token'))
      logout();
  }, [error]);

  const logout = () => {
    localStorage.removeItem('token');
    window.dispatchEvent(new Event("storage"));
    navigate('/login');
    navigate(0);
  }

  return (
    <StyleProvider hashPriority="high">
      <ConfigProvider
        theme={{
          hashed: false, // Desactivar hash de clases CSS para evitar conflictos con estilos personalizados
        }}
      >
        <LoadScript
          googleMapsApiKey={GOOGLE_API_KEY || ''}
          loadingElement={<></>}
          libraries={['places']}
        >
          <div className="Onboarding">
            <ApolloAppProvider>
              <AppProvider>
                <OnboardingApp />
              </AppProvider>
            </ApolloAppProvider>
          </div>
        </LoadScript>
      </ConfigProvider>
    </StyleProvider>
  );
};

export default Onboarding;

